import { inject, Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateDoctor, UpdateDoctor, Doctor } from '../interfaces/doctor';

@Injectable({
  providedIn: 'root',
})
export class DoctorService {
  readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control':
        'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      Expires: '0',
    }),
  };
  private apiUrl: string = `${environment.api}/Doctor`;

  private http = inject(HttpClient);
  constructor() {}

  getDoctors(): Observable<Doctor[]> {
    return this.http.get<Doctor[]>(this.apiUrl, this.httpOptions);
  }
  createDoctor(doctor: CreateDoctor): Observable<any> {
    return this.http.post(this.apiUrl, doctor, this.httpOptions);
  }
  deleteDoctorById(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, this.httpOptions);
  }
  updateDoctorById(id: number, doctor: UpdateDoctor): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, doctor, this.httpOptions);
  }
  getDoctorById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`, this.httpOptions);
  }

  bulkImportDoctorData(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const headers = new HttpHeaders({
      enctype: 'multipart/form-data',
    });

    return this.http.post(`${this.apiUrl}/import?fileType=csv`, formData, {
      headers,
    });
  }
}
